var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"loading-screen fade-in"},[_c('v-progress-circular',{staticClass:"loading-circle",attrs:{"size":100,"width":5,"color":"colorPrimary2","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }